<template>
  <div>
    <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
      <div class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8">
        <div class="m-auto">
          <!-- actual modal -->
          <div class="w-[90vw] lg:w-[1000px] mx-auto box-effect rounded-[10px] bg-white">
            <header id="title" class="bg-primary pl-5 pr-2.5 py-3 flex justify-between items-center rounded-t-[10px]">
              <span class="text-white text-[14px]">แก้ไขข้อมูลผู้ใช้งาน</span>
              <CloseIcon @click="closeModal"
                class="w-6 h-6 text-primary bg-white inline-block rounded-full cursor-pointer" />
            </header>
            <div v-if="editMode" class="p-5 flex flex-col md:flex-row gap-[30px]">
              <div class="mx-auto">
                <UploadImage :image="copiedFormData?.image" @update:image="handleImageUpload" />
              </div>
              <section class="flex-1">
                <form @submit.prevent="updateProfile">
                  <div class="overflow-auto mb-4 pr-2.5">
                    <div class="flex flex-col gap-4">
                      <div class="flex flex-col md:flex-row gap-4">
                        <SelectBoxComponent :selectContainerClass="'w-full min-w-[140px] sm:max-w-[140px]'"
                          :inputId="'prefix_id'" :keyValue="'id'" :keyName="'name'" :options="allPrefix"
                          :value="copiedFormData.prefix_id" :label="'คำนำหน้า'" :placeholder="'เลือกคำนำหน้า'"
                          :warningMessage="errors.prefix_id" @update:modelValue="
                            (res) => {
                              copiedFormData.prefix_id = res;
                            }
                          " />
                        <Input class="flex-1" id="firstname" label="ชื่อ" placeholder="ชื่อ"
                          v-model="copiedFormData.firstname" :error="errors?.firstname" />
                        <Input class="flex-1" id="lastname" label="นามสกุล" placeholder="นามสกุล"
                          v-model="copiedFormData.lastname" :error="errors?.lastname" />
                      </div>
                      <Input inputType="phone" id="phone" label="เบอร์โทรติดต่อ" placeholder="เบอร์โทรติดต่อ" digitsOnly digitsMaxLength="10"
                        v-model="copiedFormData.phone" :error="errors?.phone" />
                      <Input id="username" label="ชื่อผู้ใช้งาน" placeholder="ชื่อผู้ใช้งาน"
                        v-model="copiedFormData.username" :error="errors?.username" checkOnlyEnglish />
                      <Input inputType="email" id="email" label="อีเมล" placeholder="อีเมล"
                        v-model="copiedFormData.email" :error="errors?.email" checkOnlyEnglish />
                    </div>
                    <hr class="my-4" />
                    <div class="flex flex-col gap-4">
                      <SelectBoxComponent :inputId="'type'" :keyValue="'id'" :keyName="'name'"
                        :options="Selector.officerTypeOption" :value="copiedFormData.type" :label="'ประเภทเจ้าหน้าที่'"
                        :placeholder="'ประเภทเจ้าหน้าที่'" :warningMessage="errors.type" :allData="true"
                        @update:modelValue="
                          (res) => {
                            copiedFormData.type = res?.id || '';
                            handleTypeSelection(res);
                          }
                        " />
                      <div>
                        <div class="flex flex-col gap-[8px]">
                          <div class="label">พื้นที่ ที่สังกัด</div>
                          <div class="flex flex-col md:flex-row gap-4 md:items-start mb-4">
                            <SelectBoxComponent :searchable="true" :allowEmpty="true" :inputId="'provinceSelectorModal'"
                              :keyValue="'provinceCode'" :keyName="'provinceNameTh'" :value="copiedFormData.province_id"
                              :placeholder="'พื้นที่ ที่สังกัด'" :disabled="copiedFormData.type === 1"
                              @update:modelValue="
                                (res) => {
                                  copiedFormData.province_id = res;
                                  copiedFormData.district_id = '';
                                }
                              " />
                            <SelectBoxComponent :searchable="true" :allowEmpty="true" :inputId="'districtSelectorModal'"
                              :keyValue="'districtCode'" :keyName="'districtNameTh'" :value="copiedFormData.district_id"
                              :provinceCode="copiedFormData.province_id" :placeholder="'เลือก เขต/อำเภอ'"
                              :warningMessage="errors.district_id" @update:modelValue="
                                (res) => {
                                  copiedFormData.district_id = res;
                                }
                              " />
                          </div>
                        </div>
                        <div class="flex flex-col md:flex-row gap-4 md:items-start">
                          <SelectBoxComponent v-if="copiedFormData.type == 1" :inputId="'department_id'"
                            :keyValue="'id'" :keyName="'name'" :options="departmentOptions"
                            :value="copiedFormData.department_id" :label="'สังกัดหน่วยงาน'"
                            :placeholder="'สังกัดหน่วยงาน'" :warningMessage="errors.department_id" @update:modelValue="
                              (res) => {
                                copiedFormData.department_id = res;
                              }
                            " />
                          <SelectBoxComponent :inputId="'position_id'" :keyValue="'id'" :keyName="'name'"
                            :options="positionOptions" :value="copiedFormData.position_id" :label="'ตำแหน่งงาน'"
                            :placeholder="'เลือกตำแหน่งงาน'" :warningMessage="errors.position_id" @update:modelValue="
                              (res) => {
                                copiedFormData.position_id = res;
                              }
                            " />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="flex items-center justify-end gap-2.5">

                    <button type="button" class="btn-secondary w-1/2 md:w-[150px] min-h-[50px] px-4"
                      @click="editMode = false">
                      ยกเลิก
                    </button>
                    <button
                      class="btn w-1/2 md:w-[150px] min-h-[50px] flex justify-center items-center gap-2 PC_Body1-R disabled:!text-grey-light disabled:!bg-secondary-light disabled:!border-secondary-light disabled:!cursor-not-allowed"
                      type="submit" :disabled="!formFilled">
                      <span>บันทึก</span>
                    </button>
                  </div>
                </form>
              </section>
            </div>
            <div v-else class="p-5">
              <div class="flex md:flex-row flex-col gap-[30px] mb-4">
                <img :src="formData.image" alt="Profile Image" class="mx-auto md:mx-0 w-40 h-40" />
                <div class="space-y-4 flex-1 overflow-auto">
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">ชื่อ - นามสกุล</span>
                    <span class="text-base">{{ formData.firstname }} {{ formData.lastname }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">เบอร์โทรติดต่อ</span>
                    <span class="text-base">{{ formData.phone }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">ชื่อผู้ใช้งาน</span>
                    <span class="text-base">{{ formData.username }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">อีเมล</span>
                    <span class="text-base">{{ formData.email }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">ประเภทเจ้าหน้าที่</span>
                    <span class="text-base bg-soft-pink p-1.5">{{
                      formData.type_name
                      }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">พื้นที่</span>
                    <span class="text-base">อ.{{ formData.district_name_th }} จ.{{
                      formData.province_name_th
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">หน่วยงาน</span>
                    <span class="text-base bg-soft-pink p-1.5">{{
                      formData.department_name || "-"
                      }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">ตำแหน่งงาน</span>
                    <span class="text-base">{{
                      formData.position_name || "-"
                      }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">สังกัดทีม</span>
                    <span class="text-base">{{
                      formData.team_name || "-"
                      }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">สังกัดศูนย์พักพิง</span>
                    <span class="text-base">{{
                      formData.shelter_name || "-"
                      }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">ตำแหน่งงานภายในศูนย์</span>
                    <span class="text-base">{{
                      formData.shelter_position_name || "-"
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="w-full flex justify-end items-center gap-2.5">
                <button class="text-danger-light text-sm underline px-4 hover:text-[#B73439] duration-200"
                  @click="deleteAccount">
                  ลบบัญชีผู้ใช้งาน
                </button>
                <div class="w-1/2 md:w-auto text-end">
                  <button class="btn w-full md:w-[118px] !min-h-[50px] px-4" @click="editMode = true">
                    แก้ไขข้อมูล
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <StatusModal ref="StatusModalRef" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, inject, watch } from "vue";
import { useRouter } from "vue-router";
import { Selector } from "@/components/Utilities/javascripts/constants";
import axios from "axios";
import { useAuthStore } from "../../pinia/authStore";
import { useUsersStore } from "../../pinia/users";
import { useDepartmentStore } from "../../pinia/department";
import { usePositionStore } from "../../pinia/position";
import { storeToRefs } from "pinia";
import { usePrefixStore } from "../../pinia/prefix";

const loader = inject("loader");
const emit = defineEmits(["refresh"]);

const router = useRouter();
const { allPrefix } = storeToRefs(usePrefixStore());
const modalIsOpened = ref(false);
const StatusModalRef = ref("");
const editMode = ref(false);
// const { prefix } = useUsersStore();
// const officerTypeOptions = ref([
//   {
//     id: 1,
//     type: "ในพื้นที่",
//   },
//   {
//     id: 2,
//     type: "นอกพื้นที่",
//   },
// ]);
const formData = ref({});
const copiedFormData = ref({});
const errors = ref();
const img = ref("");

// computed properties
const departmentOptions = computed(() => {
  return useDepartmentStore().allDepartment;
});
const positionOptions = computed(() => {
  return usePositionStore().allPosition;
});
const formFilled = computed(() => {
  return (
    !!copiedFormData.value.firstname &&
    !!copiedFormData.value.lastname &&
    !!copiedFormData.value.phone &&
    !!copiedFormData.value.username &&
    !!copiedFormData.value.email &&
    !!copiedFormData.value.province_id &&
    !!copiedFormData.value.district_id &&
    !!copiedFormData.value.position_id &&
    (copiedFormData.value.type !== 1 || !!copiedFormData.value.department_id)
  );
});

// methods
const openModal = async () => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
  formData.value = await useAuthStore().getProfile();
  console.log(useAuthStore());
};

// const handleOutsideClick = (event) => {
//     // Check if the click target is inside a teleported dropdown
//     const isInsideDropdown = event.target.closest('.dropdown') ||
//                             event.target.closest('[id^="dropdown-"]') ||
//                             event.target.closest('.dropdownContainer');

//     // Only close modal if not clicking inside a dropdown
//     if (!isInsideDropdown) {
//         closeModal();
//     }
// };

const closeModal = () => {
  editMode.value = false;
  modalIsOpened.value = false;
  // formData.value = {};
  errors.value = "";
  document.body.style.overflow = "auto";
};

const handleImageUpload = (imgData) => {
  img.value = imgData;
};

const updateProfile = async () => {
  let payload = {
    email: copiedFormData.value.email,
    username: copiedFormData.value.username,
    prefix_id: copiedFormData.value.prefix_id,
    firstname: copiedFormData.value.firstname,
    lastname: copiedFormData.value.lastname,
    phone: copiedFormData.value.phone,
    type: copiedFormData.value.type,
    district_id: copiedFormData.value.district_id,
    department_id: copiedFormData.value.department_id || '',
    position_id: copiedFormData.value.position_id,
  };

  // เงื่อนไข image
if (img.value === null) {
  payload.image = '';
} else if (img.value !== '') {
  payload.image = img.value;
}

  try {
    // loader.value.showLoader();
    const response = await useAuthStore().updateProfile(
      payload,
      copiedFormData.value.id
    );
    if (response.status === 200) {
      closeModal();
      // loader.value.hideLoader();
      StatusModalRef.value.openModal(
        "success",
        { subHeader: response.data.message },
        ""
      );
      emit("refresh");
    }
  } catch (error) {
    errors.value = error.response.data.errors;
    // loader.value.hideLoader();
    console.log(error);
  }
};

const handleTypeSelection = async (value) => {
  if (value.id === 2) {
    copiedFormData.value.province_id = "";
    copiedFormData.value.district_id = "";
    copiedFormData.value.department_id = "";
  } else {
    copiedFormData.value.province_id = await JSON.parse(localStorage.getItem("user_province_id"));;
    copiedFormData.value.district_id = "";
  }
  console.log(copiedFormData.value);
};

const deleteAccount = async () => {
  StatusModalRef.value.openModal("warning", {
    subHeader: `หากลบบัญชีผู้ใช้งาน
  เจ้าของบัญชีจะไม่สามารถเข้าสู่ระบบได้อีก ต้องการลบบัญชีผู้ใช้งานหรือไม่`,
    closeButtonText: "ปิดหน้าต่าง",
    submitButtonText: "ลบบัญชีผู้ใช้งาน",
    onSubmit: async () => {
      try {
        const response = await axios.delete(`/profile`);
        if (response.status === 200) {
          await useAuthStore().logout();
          closeModal();
          router.push("/delete-account-success");
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          StatusModalRef.value.openModal("error", {
            subHeader:
              error.response.data.message ||
              `ขออภัย ไม่สามารถลบได้
              เนื่องจากบัญชีถูกผูกกับทีมปฎิบัติงาน
              หรือติดนัดหมายอยู่`,
          });
        }
        console.error("Error deleting account:", error);
      }
    },
  });
};

onMounted(async () => {
  // loader.value.showLoader();
  await useDepartmentStore().getAllDepartment();
  await usePositionStore().getAllPosition();
  // loader.value.hideLoader();
});

watch(
  () => editMode.value,
  (value) => {
    if (value) {
      copiedFormData.value = { ...formData.value };
      errors.value = {};
    }
  }
);

defineExpose({ openModal });
</script>

<style lang="scss" scoped>
.label {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
  letter-spacing: 0.1px;
}
</style>
